import { render, staticRenderFns } from "./InsuredForm.vue?vue&type=template&id=a684cafc&"
import script from "./InsuredForm.vue?vue&type=script&lang=js&"
export * from "./InsuredForm.vue?vue&type=script&lang=js&"
import style0 from "./InsuredForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports